export default __webpack_public_path__ + "locales/ar-SA/PDFFormDialog.json?hash=ab381c42aea5fa0322a967343aa2c6c9";